import {getCurrentLanguage} from './i18n.js';

const LEADS_ENDPOINT = 'https://auth.loyol.ai/seller/leads';
const UTM_FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

function createSubmissionId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, character => {
    const random = Math.floor(Math.random() * 16);
    const value = character === 'x' ? random : ((random & 0x3) | 0x8);
    return value.toString(16);
  });
}

function getCampaignData() {
  const searchParams = new URLSearchParams(window.location.search);

  return UTM_FIELDS.reduce((campaign, field) => {
    const value = searchParams.get(field);
    if (value) campaign[field] = value;
    return campaign;
  }, {});
}

function setFormState(form, state) {
  form.dataset.state = state;
  const submitButton = form.querySelector('[type="submit"]');
  const fields = form.querySelectorAll('input, textarea, button');
  const status = form.querySelector('[data-contact-status]');

  fields.forEach(field => {
    field.disabled = state === 'sending';
  });

  if (submitButton) submitButton.setAttribute('aria-disabled', state === 'sending' ? 'true' : 'false');
  if (status) status.setAttribute('aria-live', state === 'error' ? 'assertive' : 'polite');
}

export function initContactForms({pageName, campaignIntent, pushEvent, pushGa4Event}) {
  document.querySelectorAll('[data-contact-form]').forEach(form => {
    form.dataset.startedAt = String(Date.now());
    form.dataset.submissionId = createSubmissionId();

    let started = false;
    form.addEventListener('focusin', () => {
      if (started) return;
      started = true;
      pushEvent({
        event: 'form_start',
        placement: 'contact',
        destination: 'contact_form',
        campaign_intent: campaignIntent,
      });
    });

    form.addEventListener('submit', async event => {
      event.preventDefault();

      if (!form.reportValidity() || form.dataset.state === 'sending') return;

      const formData = new FormData(form);
      const payload = {
        id: form.dataset.submissionId,
        started_at: Number(form.dataset.startedAt),
        source: pageName,
        locale: getCurrentLanguage(),
        page_url: window.location.href,
        name: formData.get('name'),
        email: formData.get('email'),
        company: formData.get('company'),
        message: formData.get('message'),
        fax: formData.get('fax'),
        ...getCampaignData(),
      };
      setFormState(form, 'sending');

      pushEvent({
        event: 'form_submit',
        placement: 'contact',
        destination: 'contact_form',
        campaign_intent: campaignIntent,
      });

      try {
        const response = await fetch(LEADS_ENDPOINT, {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(payload),
        });

        if (!response.ok) throw new Error(`Lead endpoint returned ${response.status}`);

        setFormState(form, 'success');
        pushEvent({
          event: 'lead_submitted',
          placement: 'contact',
          destination: 'contact_form',
          campaign_intent: campaignIntent,
        });
        pushGa4Event('generate_lead', {
          lead_source: 'contact_form',
          placement: 'contact',
          destination: 'contact_form',
        });
        form.reset();
      } catch (error) {
        console.error('Could not submit Seller lead:', error.message);
        setFormState(form, 'error');
        form.dataset.submissionId = form.dataset.submissionId || createSubmissionId();
      }
    });

    form.addEventListener('input', () => {
      if (form.dataset.state === 'error') setFormState(form, 'idle');
    });
  });
}
